import HFComplianceStatus from './HFComplianceStatus'
import '@components/Compliance/Compliance.sass'

export default HFComplianceStatus
